import { call, put, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  remove as removeUserGroup
} from 'store/redux/userGroups'
import {
  remove as removeUserGroupFromView
} from '../redux/userGroups'
import sweetalert from 'sweetalert2'

export default function * requestRemoveUserGroup (action) {
  const { id, onSuccess } = action.payload

  const state = yield select()

  const userGroup = state['view-userGroups'].userGroups.userGroupsById[id]

  let currentIndex
  if (userGroup) {
    currentIndex = state['view-userGroups'].userGroups.userGroups.indexOf(id)
  }

  let optimisticAction
  if (userGroup && !isNaN(currentIndex)) {
    optimisticAction = yield optimisticPut(removeUserGroupFromView({
      id
    }))
  }

  try {
    yield call(apiAction, 'RemoveGroup', {
      id
    })

    if (userGroup && !isNaN(currentIndex)) {
      yield optimisticAction.commit()
    }

    yield put(removeUserGroup({
      id
    }))

    if (onSuccess) onSuccess()
  } catch (error) {
    if (userGroup && !isNaN(currentIndex)) {
      yield optimisticAction.revert()
    }

    if (error.code === 520) { // GroupHasAssociations
      try {
        yield call(sweetalert, {
          text: state.kanbo.locale.messages['USER_GROUP_REMOVE_IN_USE_ERROR'],
          type: 'error'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
